import { render } from "./Aksi.vue?vue&type=template&id=0b03a7d5"
import script from "./Aksi.vue?vue&type=script&lang=js"
export * from "./Aksi.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__